<div class="education-course-banner-area jarallax" data-jarallax='{"speed": 0.3}'>
    <!-- <div class="container">
        <div class="education-course-banner-content">
            <h1>Cabinet d'Accompagnement <br> de Coaching et d'Education</h1>
            <h4 style="color: #ff6e1c">Ste Louise de Siméon</h4>
            <div class="btn-box">
                <a class="default-btn cursor" (click)="show()"><i class='bx bx-move-horizontal icon-arrow before'></i><span class="label">J'inscris mon enfant</span><i class="bx bx-move-horizontal icon-arrow after"></i></a>
            </div>
        </div>
    </div>
    <div class="education-categories-item technology">
        <div class="icon">
            <i class="bx bx-shape-triangle"></i>
        </div>
        <h3>
            <a href="#">Difficulté en apprentissage</a>
        </h3>
        <span>Chaque enfant a son style d'apprentissage</span>
    </div> -->
    <!-- <div class="education-categories-item marketing">
        <div class="icon">
            <i class="bx bx-target-lock"></i>
        </div>
        <h3>
            <a>Manque de concentration</a>
        </h3>
        <span>De votre enfant à étudier</span>
    </div> -->
    <!-- <div class="education-categories-item business">
        <div class="icon">
            <i class="bx bx-briefcase-alt-2"></i>
        </div>
        <h3>
            <a href="#">Manque de temps</a>
        </h3>
        <span>Vous sortez tôt et rentrez tard à la maison</span>
    </div>
    <div class="education-categories-item health">
        <div class="icon">
            <i class="bx bx-first-aid"></i>
        </div>
        <h3>
            <a href="#">Espace de concentration</a>
        </h3>
        <span>Beaucoup d'heures devant les écrans <br> nuit à la santé de l'enfant</span>
    </div> -->
    <!-- <div class="education-categories-item science">
        <div class="icon">
            <i class="bx bxs-drink"></i>
        </div>
        <h3>
            <a routerLink="/courses-3-columns-style-1">Parent occupé</a>
        </h3>
        <span>Difficulté à suivre son évolution</span>
    </div> -->
    <!-- <div class="education-categories-item graphics-design">
        <div class="icon">
            <i class="bx bx-layer"></i>
        </div>
        <h3>
            <a href="#">Suivi scolaire de qualité</a>
        </h3>
        <span>Les nouvelles approches pédagogiques <br> et les mutations socio-professionnelles <br> ne me facilitent plus le suivi de mon enfant</span>
    </div> -->
    <div class="container">
        <div class="row">
            <div class="col-6 bg-warn text1">
                Le meilleur endroit pour
                apprendre et grandir.
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-6 text2">
                Nous accompagnons les rêves, éveillons les talents
                pour construire ensemble un capital humain qui inspire
                le changement et transforme des vies.
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-6">
                <a class="default-btn cursor" (click)="show()"><i class='bx bx-move-horizontal icon-arrow before'></i><span class="label">J'inscris mon enfant</span><i class="bx bx-move-horizontal icon-arrow after"></i></a>
            </div>
        </div>
    </div>
</div>